/// Override bm-menu-wrap class's inline styles without !important
/// Necessary for pushable-element effect

export const bmMenuWrapStyle = () => {
  const width = window.innerWidth;

  if (width < 1100)
    return {
      fontSize: '1.2em',
      width: '300px'
    };
  else if (width > 1480)
    return {
      fontSize: '1.2em',
      width: '15vw'
    };
  else
    return {
      background: '#23354b',
      fontSize: '.97em',
      overflow: 'visible',
      width: '20vw'
    };
};

export const pushElements = (marginLeft, display) => {
  [...document.getElementsByClassName('pushable-element')].map(
    elem => (elem.style.marginLeft = marginLeft)
  );
  document.getElementById('navbar-logo-container').style.display = display;
};
